import { ButtonIcon } from '@prisjakt/ui/button';
import { useAppContext } from 'src/components/app-context';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import { H4Text } from '@prisjakt/ui/text/variants';
import React, { ReactNode } from 'react';
import { Message, MessageGroup, MessageWrapper } from './styles';

export type PromptMessageType = {
  message: string;
  buttonText: string;
  icon: ReactNode;
  buttonOnClick: () => void;
  iconPosition: 'left' | 'right';
};

type PromptMessageProps = {
  message: PromptMessageType;
};

export const PromptMessage = ({ message }: PromptMessageProps) => {
  const { market } = useAppContext();
  return (
    <MessageWrapper $elevated>
      <img
        alt="no offers"
        width="52px"
        height="52px"
        src={`${market.cdn}/g/rfe/illustrations/no-offers-illustration_112x112.png`}
      />
      <MessageGroup>
        <Message>
          <H4Text>{message.message}</H4Text>
        </Message>
        <PrimaryButton onClick={() => message.buttonOnClick()}>
          {message.iconPosition === 'left' && (
            <ButtonIcon>{message.icon}</ButtonIcon>
          )}
          {message.buttonText}
          {message.iconPosition === 'right' && (
            <ButtonIcon>{message.icon}</ButtonIcon>
          )}
        </PrimaryButton>
      </MessageGroup>
    </MessageWrapper>
  );
};
